<script>
import Topbar from '@components/topbar'
import AppMenu from '@components/app-menu'
export default {
  components: { Topbar, AppMenu },
  data() {
    return {
      showMobileMenu: false,
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},
    }
  },
  created: () => {
    document.body.classList.remove('authentication-bg')
    document.body.classList.remove('authentication-bg-pattern')
    document.body.setAttribute('data-layout', 'topnav')
    document.body.classList.remove('right-bar-enabled')
    document.body.classList.remove('left-side-menu-condensed')
    document.body.classList.remove('boxed-layout')
  },
  methods: {
    toggleMenu() {
      this.showMobileMenu = !this.showMobileMenu
    }
  },
}
</script>

<template>
  <div class="inpanel">
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->
    <Topbar :user="user" :is-menu-opened="showMobileMenu" />
    <div class="topnav shadow-sm">
      <div class="container-fluid">
        <nav class="navbar navbar-light navbar-expand-lg topbar-nav">
          <b-collapse
            id="topnav-menu-content"
            v-model="showMobileMenu"
            class="navbar-collapse"
          >
            <AppMenu :user="user" mode="horizontal" />
          </b-collapse>
        </nav>
      </div>
    </div>
    <div class="content-page">
      <div class="content">
        <div class="container-fluid">
          <slot :user="user"/>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <footer class="footer_part">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 mt-5 text-center">
              <img src="@assets/images/logo-kejak.png" alt class="footer-logo pt-2" />
              <div class="copyright_text">
                <p>© Pedoman Narkotika 2022 - Indexalaw</p> 
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>

  </div>
</template>

<style type="text/css">
  body{
    background-color: #f9f9f9 !important;
    background-image: none !important;
  }
  .bordered {
    box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
  }
  .task-search .search-input{
    z-index: 0 !important;
  }
  .navbar-custom{
    position: fixed !important;
    border-bottom: 1px solid #cccccc;
  }

  .topnav {
    position: fixed;
    background: #f3f3f3;
    border-bottom: solid 1px #ccc;
    margin-top: 70px;
    width: 100%;
    z-index: 1;
  }
  .content-page {
    padding: 10em 0 10em 0 !important;
    border-bottom: solid 1px #ccc;
  }
  .inpanel .content-page {
    border-bottom: none;
  }
  @media (max-width: 767.98px){
    .content-page {
      padding: 5em 0 5px 0 !important;
    }
  }
  footer{
    padding: 20px 0 20px;
  }
  footer img{
    width: 50px;
    margin-bottom: 20px;
  }
  footer p {
    font-size: 14px;
  }
  .form-control:disabled, .form-control[readonly] {
    background-color: #f9f9f9;
  }
  .vue-dropzone {
    background: #fff;
    border: 1px solid #e2e7f1 !important;
    border-radius: 6px;
    cursor: pointer;
  }
  .vue-dropzone .dz-message{
    margin: 1.5em 0 !important;
  }
  .dropzone .dz-preview {
    margin: 0px !important; 
    margin-right: 15px !important;
    min-height: 100px;
    border: 1px solid #e2e7f1;
    border-radius: 5px;
  }
  .ql-editor {
      font-size: 14px;
  }
  .dropzone .dz-preview .dz-image img {
    display: block;
    width: 100% !important;
  }
  .input-group-append{
    z-index: 0;
  }
  .task-search .icon-search{
    z-index: 0;
  }
  .topbar-nav .metismenu li.active > a svg{
    color: #2f2f2f;
  }
  .topbar-nav .metismenu li.active > a{
    color: #2f2f2f;
  }
  .result-label-l{
    font-size: 20px;
    font-weight: bold;
  }
  .muted{
    color: #d2d2d2;
  }
  .card .header-title{
    background-color: #f9f9f9;
    /*background-color: #f8f9fa;*/ 
    text-shadow: 1px 1px 1px rgb(49 49 49 / 40%);
  }
  .card{

    -webkit-box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
    box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
    -webkit-backdrop-filter: blur(4px) brightness(88%) saturate(72%);
  }

  @-webkit-keyframes passing-through{0%{opacity:0;-webkit-transform:translateY(40px);-moz-transform:translateY(40px);-ms-transform:translateY(40px);-o-transform:translateY(40px);transform:translateY(40px)}30%, 70%{opacity:1;-webkit-transform:translateY(0px);-moz-transform:translateY(0px);-ms-transform:translateY(0px);-o-transform:translateY(0px);transform:translateY(0px)}100%{opacity:0;-webkit-transform:translateY(-40px);-moz-transform:translateY(-40px);-ms-transform:translateY(-40px);-o-transform:translateY(-40px);transform:translateY(-40px)}}@-moz-keyframes passing-through{0%{opacity:0;-webkit-transform:translateY(40px);-moz-transform:translateY(40px);-ms-transform:translateY(40px);-o-transform:translateY(40px);transform:translateY(40px)}30%, 70%{opacity:1;-webkit-transform:translateY(0px);-moz-transform:translateY(0px);-ms-transform:translateY(0px);-o-transform:translateY(0px);transform:translateY(0px)}100%{opacity:0;-webkit-transform:translateY(-40px);-moz-transform:translateY(-40px);-ms-transform:translateY(-40px);-o-transform:translateY(-40px);transform:translateY(-40px)}}@keyframes passing-through{0%{opacity:0;-webkit-transform:translateY(40px);-moz-transform:translateY(40px);-ms-transform:translateY(40px);-o-transform:translateY(40px);transform:translateY(40px)}30%, 70%{opacity:1;-webkit-transform:translateY(0px);-moz-transform:translateY(0px);-ms-transform:translateY(0px);-o-transform:translateY(0px);transform:translateY(0px)}100%{opacity:0;-webkit-transform:translateY(-40px);-moz-transform:translateY(-40px);-ms-transform:translateY(-40px);-o-transform:translateY(-40px);transform:translateY(-40px)}}@-webkit-keyframes slide-in{0%{opacity:0;-webkit-transform:translateY(40px);-moz-transform:translateY(40px);-ms-transform:translateY(40px);-o-transform:translateY(40px);transform:translateY(40px)}30%{opacity:1;-webkit-transform:translateY(0px);-moz-transform:translateY(0px);-ms-transform:translateY(0px);-o-transform:translateY(0px);transform:translateY(0px)}}@-moz-keyframes slide-in{0%{opacity:0;-webkit-transform:translateY(40px);-moz-transform:translateY(40px);-ms-transform:translateY(40px);-o-transform:translateY(40px);transform:translateY(40px)}30%{opacity:1;-webkit-transform:translateY(0px);-moz-transform:translateY(0px);-ms-transform:translateY(0px);-o-transform:translateY(0px);transform:translateY(0px)}}@keyframes slide-in{0%{opacity:0;-webkit-transform:translateY(40px);-moz-transform:translateY(40px);-ms-transform:translateY(40px);-o-transform:translateY(40px);transform:translateY(40px)}30%{opacity:1;-webkit-transform:translateY(0px);-moz-transform:translateY(0px);-ms-transform:translateY(0px);-o-transform:translateY(0px);transform:translateY(0px)}}@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);-o-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.1);-moz-transform:scale(1.1);-ms-transform:scale(1.1);-o-transform:scale(1.1);transform:scale(1.1)}20%{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);-o-transform:scale(1);transform:scale(1)}}@-moz-keyframes pulse{0%{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);-o-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.1);-moz-transform:scale(1.1);-ms-transform:scale(1.1);-o-transform:scale(1.1);transform:scale(1.1)}20%{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);-o-transform:scale(1);transform:scale(1)}}@keyframes pulse{0%{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);-o-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.1);-moz-transform:scale(1.1);-ms-transform:scale(1.1);-o-transform:scale(1.1);transform:scale(1.1)}20%{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);-o-transform:scale(1);transform:scale(1)}}.dropzone,.dropzone *{box-sizing:border-box}.dropzone{min-height:150px;border:2px solid rgba(0,0,0,0.3);background:white;padding:20px 20px}.dropzone.dz-clickable{cursor:pointer}.dropzone.dz-clickable *{cursor:default}.dropzone.dz-clickable .dz-message,.dropzone.dz-clickable .dz-message *{cursor:pointer}.dropzone.dz-started .dz-message{display:none}.dropzone.dz-drag-hover{border-style:solid}.dropzone.dz-drag-hover .dz-message{opacity:0.5}.dropzone .dz-message{text-align:center;margin:2em 0}.dropzone .dz-preview{position:relative;display:inline-block;vertical-align:top;margin:16px;min-height:100px}.dropzone .dz-preview:hover{z-index:1000}.dropzone .dz-preview:hover .dz-details{opacity:1}.dropzone .dz-preview.dz-file-preview .dz-image{border-radius:20px;background:#999;background:linear-gradient(to bottom, #eee, #ddd)}.dropzone .dz-preview.dz-file-preview .dz-details{opacity:1}.dropzone .dz-preview.dz-image-preview{background:white}.dropzone .dz-preview.dz-image-preview .dz-details{-webkit-transition:opacity 0.2s linear;-moz-transition:opacity 0.2s linear;-ms-transition:opacity 0.2s linear;-o-transition:opacity 0.2s linear;transition:opacity 0.2s linear}.dropzone .dz-preview .dz-remove{font-size:14px;text-align:center;display:block;cursor:pointer;border:none}.dropzone .dz-preview .dz-remove:hover{text-decoration:underline}.dropzone .dz-preview:hover .dz-details{opacity:1}.dropzone .dz-preview .dz-details{z-index:20;position:absolute;top:0;left:0;opacity:0;font-size:13px;min-width:100%;max-width:100%;padding:2em 1em;text-align:center;color:rgba(0,0,0,0.9);line-height:150%}.dropzone .dz-preview .dz-details .dz-size{margin-bottom:1em;font-size:16px}.dropzone .dz-preview .dz-details .dz-filename{white-space:nowrap}.dropzone .dz-preview .dz-details .dz-filename:hover span{border:1px solid rgba(200,200,200,0.8);background-color:rgba(255,255,255,0.8)}.dropzone .dz-preview .dz-details .dz-filename:not(:hover){overflow:hidden;text-overflow:ellipsis}.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span{border:1px solid transparent}.dropzone .dz-preview .dz-details .dz-filename span,.dropzone .dz-preview .dz-details .dz-size span{background-color:rgba(255,255,255,0.4);padding:0 0.4em;border-radius:3px}.dropzone .dz-preview:hover .dz-image img{-webkit-transform:scale(1.05, 1.05);-moz-transform:scale(1.05, 1.05);-ms-transform:scale(1.05, 1.05);-o-transform:scale(1.05, 1.05);transform:scale(1.05, 1.05);-webkit-filter:blur(8px);filter:blur(8px)}.dropzone .dz-preview .dz-image{border-radius:20px;overflow:hidden;width:120px;height:120px;position:relative;display:block;z-index:10}.dropzone .dz-preview .dz-image img{display:block}.dropzone .dz-preview.dz-success .dz-success-mark{-webkit-animation:passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);-moz-animation:passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);-ms-animation:passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);-o-animation:passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);animation:passing-through 3s cubic-bezier(0.77, 0, 0.175, 1)}.dropzone .dz-preview.dz-error .dz-error-mark{opacity:1;-webkit-animation:slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);-moz-animation:slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);-ms-animation:slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);-o-animation:slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);animation:slide-in 3s cubic-bezier(0.77, 0, 0.175, 1)}.dropzone .dz-preview .dz-success-mark,.dropzone .dz-preview .dz-error-mark{pointer-events:none;opacity:0;z-index:500;position:absolute;display:block;top:50%;left:50%;margin-left:-27px;margin-top:-27px}.dropzone .dz-preview .dz-success-mark svg,.dropzone .dz-preview .dz-error-mark svg{display:block;width:54px;height:54px}.dropzone .dz-preview.dz-processing .dz-progress{opacity:1;-webkit-transition:all 0.2s linear;-moz-transition:all 0.2s linear;-ms-transition:all 0.2s linear;-o-transition:all 0.2s linear;transition:all 0.2s linear}.dropzone .dz-preview.dz-complete .dz-progress{opacity:0;-webkit-transition:opacity 0.4s ease-in;-moz-transition:opacity 0.4s ease-in;-ms-transition:opacity 0.4s ease-in;-o-transition:opacity 0.4s ease-in;transition:opacity 0.4s ease-in}.dropzone .dz-preview:not(.dz-processing) .dz-progress{-webkit-animation:pulse 6s ease infinite;-moz-animation:pulse 6s ease infinite;-ms-animation:pulse 6s ease infinite;-o-animation:pulse 6s ease infinite;animation:pulse 6s ease infinite}.dropzone .dz-preview .dz-progress{opacity:1;z-index:1000;pointer-events:none;position:absolute;height:16px;left:50%;top:50%;margin-top:-8px;width:80px;margin-left:-40px;background:rgba(255,255,255,0.9);-webkit-transform:scale(1);border-radius:8px;overflow:hidden}.dropzone .dz-preview .dz-progress .dz-upload{background:#333;background:linear-gradient(to bottom, #666, #444);position:absolute;top:0;left:0;bottom:0;width:0;-webkit-transition:width 300ms ease-in-out;-moz-transition:width 300ms ease-in-out;-ms-transition:width 300ms ease-in-out;-o-transition:width 300ms ease-in-out;transition:width 300ms ease-in-out}.dropzone .dz-preview.dz-error .dz-error-message{display:block}.dropzone .dz-preview.dz-error:hover .dz-error-message{opacity:1;pointer-events:auto}.dropzone .dz-preview .dz-error-message{pointer-events:none;z-index:1000;position:absolute;display:block;display:none;opacity:0;-webkit-transition:opacity 0.3s ease;-moz-transition:opacity 0.3s ease;-ms-transition:opacity 0.3s ease;-o-transition:opacity 0.3s ease;transition:opacity 0.3s ease;border-radius:8px;font-size:13px;top:130px;left:-10px;width:140px;background:#be2626;background:linear-gradient(to bottom, #be2626, #a92222);padding:0.5em 1.2em;color:white}.dropzone .dz-preview .dz-error-message:after{content:'';position:absolute;top:-6px;left:64px;width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #be2626}
  body {
    background-image: url(../../assets/images/bottom.png) !important;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: bottom;
    background-attachment: fixed;
  }
  .topbar-nav .metismenu li.mm-active > a svg{
    color: #fff;
  }
  .topbar-nav .metismenu li a svg{
    color: #fff;
  }
  .topbar-nav .metismenu li a:hover{
    color: #fff;
  }
  .topbar-nav .metismenu li a i{
    vertical-align: text-top !important;
  }
  .topbar-nav .metismenu li a > span{
    color: #fff;
    font-weight: 600;
    text-shadow: 1px 1px 1px rgb(49 49 49 / 40%);
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
  }
  .profile-dropdown i.feather{
    vertical-align: text-top;
  }
  .topbar-nav .metismenu li.active > a svg{
    color: #fff;
  }
  .topbar-nav .metismenu li a:hover svg, .topbar-nav .metismenu li a:focus svg, .topbar-nav .metismenu li a:active svg{
    color: #fff;
  }
  .table .thead-light th {
/*    color: #ffffff;
    background-color: #72a200;
    border-color: #709e00;*/
    color: #000000;
    background-color: #ffffff;
    border-radius: 5px;
    border-bottom: 3px solid #76a501;
  }
  .card-login {
    border-top: 3px solid #0e8635;
  }
  @media (max-width: 767.98px){
    .topbar-nav .metismenu li .nav-second-level{
      background-color: transparent;
    }
    .topbar-nav .metismenu li .nav-second-level a{
      color: #fff;
    }
    .special-right-label{
      right: 2%;
    }
  }
  .topbar-nav .metismenu li:hover svg, .topbar-nav .metismenu li:focus svg, .topbar-nav .metismenu li:active svg{
    color : #fff;
  }
  .topnav {
    background-image: url(../../assets/images/barbig2.png) !important;
    background-size: cover;
    background-position: revert;
    border-bottom: solid 1px #72a200;
  }
  .case-card-header {
    background-image: url(../../assets/images/barbig.png) !important;
    background-size: cover;
    background-position: bottom;
  }
  .card-header {
    padding: .75rem 1.25rem;
    margin-bottom: 0;
    /* background-color: #257cc7; */
    border-bottom: 0 solid rgba(0,0,0,.125);
    color: #fff;
    background-image: url(../../assets/images/barbig.png);
    background-size: cover;
    background-position: bottom;
  }
  .header-title {
    border-radius: 5px 5px 0px 0px;
    padding: .75rem 1.25rem;
    margin-bottom: 0;
    /* background-color: #257cc7; */
    border-bottom: 0 solid rgba(0,0,0,.125);
    color: #fff;
    background-image: url(../../assets/images/bar.png);
    background-size: cover;
    background-position: bottom;
  }
  .wizard-icon-circle.checked {
    background-color: #85cc01 !important;
  }
  .vue-form-wizard.md .wizard-icon-circle{
    border-color: rgb(77 126 0) !important;
  }
  .vue-form-wizard .wizard-icon-circle .wizard-icon{
    color: #4e8102;
  }
  .vue-form-wizard .wizard-icon-circle .wizard-icon-container{
    border-color: rgb(77 126 0) !important;
  }
  .vue-form-wizard .wizard-navigation .wizard-progress-with-circle .wizard-progress-bar{
    border-color: rgb(77 126 0) !important;
  }
  .wizard-icon-circle.checked{
    background-color: #e0ffc2 !important;
  }
  .card-main-wrapper{
    border-bottom: 20px solid #4d7e00;
  }
  .card-main-wrapper:after{
    content: "Pedoman Narkotika - PeNa";
    position: inherit;
    top: 19px;
    left: 10px;
    color: #fdfff7;
    letter-spacing: 1px;
    text-transform: capitalize;
    font-size: 11px;
    opacity: 76%;
  }
  .custom-control{
    z-index: 0 !important;
  }
  .header-title-inner {
    background-image: none;
    background-color: #eaeaea;
    color: #212529;
    text-shadow: none !important;
    padding: 10px !important;
    border-radius: 0px;
  }

  .card-inner {
    border-radius: 0px;
    box-shadow: none;
    border: 1px solid #eaeaea; 
    margin-bottom: 0px;
  }
  .form-control-label{
    background-color: #f8f9fa;
    border: none;
  }
  .memberatkan-target-wrapper{
    font-style: italic;
    color: red;
  }
  .meringankan-target-wrapper{
    font-style: italic;
    color: green;
  }
  .pull-right{
    float: right;
  }
  .blue{
    color: blue;
  }
  .green{
    color: #07752b;
  }
  .red-header{
    color:#5a5a5a;
    background-color: #ffe3e3 !important;
    border: 1px solid #cecece;
  }
  .green-header{
    color:#5a5a5a;
    background-color: #e9ffe3 !important;
    border: 1px solid #cecece;
  }
</style>
